// extracted by mini-css-extract-plugin
export default {"productDescription":"iea-z","featuredDescription":"jea-z","description":"kea-z","more":"lea-z","descriptionSku":"mea-z"};